import { render } from "./billDetailWithInvoice.vue?vue&type=template&id=4d046a67&scoped=true"
import script from "./billDetailWithInvoice.vue?vue&type=script&lang=js"
export * from "./billDetailWithInvoice.vue?vue&type=script&lang=js"

import "./billDetailWithInvoice.vue?vue&type=style&index=0&id=4d046a67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d046a67"]])

export default __exports__